//billing tool
export const initialState = {
  // history tab
  historyData: [],
  historyLoading: false,
  selectededTabValue: 0,
  totalCount: 0,
  billingSearchData: [],
  billingSearchLoading: false,
  billingSearchCount: 0,
  billingStatusData: [],
  billingStatusLoading: false,
  selectedRowData: [],
  approveBillLoading: false,
  billingViewLoading: false,
  billingViewCount: 0,
  billingViewData: [],

  billingContractDetails: [],
  contractStatus:false,

  billingToolGridDataLoader: false,
  billingToolGridData: [],
  billingToolGridDataCount: 0,

  billingSelectedGridData: null,
  isCustomerNumberClicked: false,
  billingDetailsTabData: [],
  billingDetailsTabCount: 0,
  billingDetailsTabLoading: false,
  isBillingDetailsTabData: false,

  billingToolNoteHeaderDataLoader: false,
  billingToolNoteHeaderData: [],
  billingToolNoteHeaderDataCount: 0,

  billingToolNoteLineDataLoader: false,
  billingToolNoteLineData: [],
  billingToolNoteLineDataCount: 0,

  billingToolNoteLineDdData: [],

  billingNoteHeaderLineSuccess: {
    create: false,
    update: false,
  },

  billingNoteHeaderLineSuccessLine: {
    create: false,
    update: false,
  },

  isBillingFromCustomer: null,

  regenerateBillLoading: false,
  isRegenerated: null,
  approveBillStatus: null,
  isPopupOpen: false,
  redirectToBillTool: false,

  billingArray:[{}],
  currentPage:1,
  isReset :false,
};
